import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/HighlightOff';

const styles = {
  button: {
    borderRadius: '50%',
    padding: 0,
    minWidth: 'auto',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#ff5722'
    }
  },
  leftIcon: {
    width: 22,
    height: 22,
    color: '#fff'
  }
};

const enhance = compose();

const button = enhance(({ classes, id, onClickAction, disabled }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={() => {
        onClickAction(id);
      }}
      className={classes.button}
      disabled={disabled}
    >
      <DeleteIcon className={classes.leftIcon} />
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
